import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  dialog: {
    minHeight: '200px !important',
    [theme.breakpoints.up('md')]: {
      width: 705,
      maxWidth: 705
    }
  }
}))
